export default __webpack_public_path__ + "static/media/3@2x.85c0e6e3.png";